<!--  -->
<template>
	<td class="columnDynamicData" :style="label=='underline'?'padding-top: 20px; padding-bottom: 0px;':''">
        <div v-if="label =='skill_id'">
            {{item.skill_name+'('+item.skill_priority+')'}}
        </div>
        <div v-if="label =='employee_lf'">
            {{item.last_name}}
        </div>
        <div v-if="label =='employee_fl'">
            {{item.first_name}}
        </div>
        <div v-if="label =='seniority'">
            {{ item.seniority ? getRoundOffSkillSeniority(item.seniority) : '' }}
        </div>
        <div v-if="label =='start'">
            {{getTime(item.call_start)}}
        </div>
        <div v-if="label =='end'">
            {{getTime(item.call_end)}}
        </div>
        <div v-if="label =='total_shifts'">
            {{item.total_shifts}}
        </div>
        <div v-if="label =='employee_phone'">
            {{item.phone_number}}
        </div>
        <div v-if="label =='confirmed'">
            {{item.confirm_by}}
        </div>
        <div v-if="label =='underline'" :style="label=='underline'?'padding-bottom: 0px;':''">
            ____________________
        </div>
        <div v-if="label =='status_id'">
            {{item.status_name}}
        </div>
        <div v-if="label =='custom_field_1'">
            <!-- {{ item.custom_field_1 }} -->
            {{ getCustomfield(item.custom_field_1) }}
        </div>
        <div v-if="label =='custom_field_2'">
            {{getCustomfield(item.custom_field_2)}}
        </div>
        <div v-if="label =='empty'">
            
        </div>
    </td>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../../global.js';
    import service from '../../../services.js';
    export default {
        //name:'columnDynamic',
        props: {
            // employee: {
            //     type: Object,
            //     required: true
            // },
            item: {
                type: Object,
                required: true
            },
            label:{
                type: String,
                required: true
            }
            // client:{
            //     type: Object,
            //     required: true
            // },
            // selectedSortType:{
            //     type: String,
            //     required: true
            // },
            // callStartTime:{
            //     type:String,
            //     required: true
            // },
            // callEndTime:{
            //     type:String,
            //     required: true
            // }
        },
        data() {
            return {
               
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
            })
        },
        methods: {
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            getFieldValue(value) {
                return (value != 'empty') ? (moment(value, "YYYY-MM-DD HH:mm:ss", true).isValid() ? this.getTime(value) : (value=='underline'?'_____________________':value)) : '';
            },
            getCustomfield(data){
                // console.log(data);
                // return JSON.parse(data).value;
                if(data != '') {
                    var customFld = "";
                    try {
                        customFld = JSON.parse(data);
                        let re = -1;
                        let re2 = -1;
                        if(customFld != '' && customFld.value)
                        {
                            re = customFld.value.search('{\"name\":');
                            let inner = "";
                            if(re>=0) {
                                inner = JSON.parse(customFld.value);
                                if(inner&&inner != ''&&inner.value)
                                    re2 = customFld.value.search('{\"name\":')
                                if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                                    return '';
                                return (inner.value);
                            }else
                            return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? (customFld.value) : '';  
                        }
                        return "";
                    } catch (ex) {
                        console.warn("Not a Valid JSON");
                        return "";
                    }                    
                }
                return "";
            },

            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                // return moment(dateTime).format('hh:mm:ss');
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            getDate(dateTime) {
                //return dateTimeConvert.globalDate(dateTime);
                //var date = dateTimeConvert.extractDateOnly(dateTime);
                return dateTimeConvert.extractDateOnly(dateTime);
            },
        },
        created() {
            // console.log(this.item);
        }   

    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/jobs/signInSheet/columnDynamicData.vue